/**
 * sanitizeHtml — centralized DOMPurify wrapper used everywhere we render
 * admin-authored or external HTML via dangerouslySetInnerHTML.
 *
 * Strips <script>, on* handlers, javascript:, data: URIs, etc.
 * Keeps the safe subset we actually use in CMS body fields.
 */
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's',
  'a', 'span', 'div',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'blockquote', 'code', 'pre',
  'img',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'src', 'alt', 'title'];

export const sanitizeHtml = (raw) => {
  if (!raw || typeof raw !== 'string') return '';
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Force-add rel="noopener noreferrer" on target=_blank links
    ADD_ATTR: ['target'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick', 'onmouseover'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'button', 'select'],
  });
};

/** Returns the `dangerouslySetInnerHTML` prop value already sanitized. */
export const dangerousSafeHtml = (raw) => ({ __html: sanitizeHtml(raw) });
